import React from "react";
import CircularProgress, {
  circularProgressClasses,
} from "@mui/material/CircularProgress";
const CircularLoader = ({ loaderClr }) => {
  return (
    <CircularProgress
      variant="indeterminate"
      disableShrink
      sx={{
        color: (theme) =>
          theme.palette.mode === "light" ? loaderClr : "var(--primary)",
        animationDuration: "2000",
        [`& .${circularProgressClasses.circle}`]: {
          strokeLinecap: "round",
        },
      }}
      size={20}
      thickness={4}
    />
  );
};

export default CircularLoader;
